import { calcularFechaFinContrato, normalizarFechaContrato } from './contratoSolapamiento';
import { enteroALetras } from './montoEnLetrasSoles';

function addDaysYmd(fechaYmd, dias) {
  const fecha = normalizarFechaContrato(fechaYmd);
  if (!fecha) return null;
  const [y, m, d] = fecha.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d + Number(dias || 0)));
  const yy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

function diasInclusive(desde, hasta) {
  const a = normalizarFechaContrato(desde);
  const b = normalizarFechaContrato(hasta);
  if (!a || !b || b < a) return 0;
  const [y1, m1, d1] = a.split('-').map(Number);
  const [y2, m2, d2] = b.split('-').map(Number);
  const t1 = Date.UTC(y1, m1 - 1, d1);
  const t2 = Date.UTC(y2, m2 - 1, d2);
  return Math.round((t2 - t1) / 86400000) + 1;
}

/**
 * Meses y días del periodo inclusive [inicio, fin],
 * alineado a inicio + N meses - 1 día.
 */
export function calcularMesesYDias(fechaInicio, fechaFin) {
  const inicio = normalizarFechaContrato(fechaInicio);
  const fin = normalizarFechaContrato(fechaFin);
  if (!inicio || !fin || fin < inicio) {
    return { meses: 0, dias: 0 };
  }

  let meses = 0;
  while (meses < 600) {
    const candidato = calcularFechaFinContrato(inicio, meses + 1, 0);
    if (!candidato || candidato > fin) break;
    meses += 1;
  }

  const finMeses = meses > 0 ? calcularFechaFinContrato(inicio, meses, 0) : null;
  const desdeDias = finMeses ? addDaysYmd(finMeses, 1) : inicio;
  const dias = diasInclusive(desdeDias, fin);

  return { meses, dias };
}

export function formatearPlazoTexto(meses, dias) {
  const m = Number(meses) || 0;
  const d = Number(dias) || 0;
  const partes = [];
  if (m > 0) partes.push(m === 1 ? '1 mes' : `${m} meses`);
  if (d > 0) partes.push(d === 1 ? '1 día' : `${d} días`);
  return partes.join(' y ');
}

export function formatearPlazoEscrito(meses, dias) {
  const m = Number(meses) || 0;
  const d = Number(dias) || 0;
  const partes = [];
  if (m > 0) partes.push(m === 1 ? `${enteroALetras(m)} MES` : `${enteroALetras(m)} MESES`);
  if (d > 0) partes.push(d === 1 ? `${enteroALetras(d)} DIA` : `${enteroALetras(d)} DIAS`);
  return partes.join(' Y ');
}

export function plazoDesdeContrato(contrato) {
  const meses = Number(contrato?.plazo_meses) || 0;
  const dias = Number(contrato?.plazo_dias) || 0;
  return formatearPlazoTexto(meses, dias) || '-';
}

export function esPlazoSoloMeses(fechaInicio, plazoMeses, fechaFin) {
  const fin = normalizarFechaContrato(fechaFin);
  const calculada = calcularFechaFinContrato(fechaInicio, plazoMeses, 0);
  return Boolean(fin && calculada && fin === calculada);
}
